<div class="flex flex-col h-full gap-y-4 overflow-hidden px-0 lg:px-10 py-4">
  <div class="flex justify-between items-end shrink-0">
    <div class="font-semibold text-xl text-(--color-text-primary)">Entrega en camino</div>

    <button
      (click)="closeModal()"
      class="border! rounded-full border-(--comp-dialog-button-close)!"
      mat-icon-button
    >
      <mat-icon class="text-(--comp-dialog-button-close)!">close</mat-icon>
    </button>
  </div>

  <div class="flex-1 min-h-0 w-full rounded-2xl overflow-hidden relative">
    <google-map height="100%" width="100%" [center]="center" [zoom]="zoom">
      @if (directionsResult()) {
        <map-directions-renderer [directions]="directionsResult()!"></map-directions-renderer>
      }
    </google-map>
  </div>
</div>
